module.exports = __webpack_public_path__ + "static/media/joyable6_preview.35e6a7b8.jpg";